<template>
	<div class="mb-5">
		<label for class="vs-input--label text-base"> {{ $t("Assigned") }}: </label>
		<!-- <cbs-input v-model="assigned" class="w-full" name="assigned" :data-vv-as="$t('Assigned')" :placeholder="`${$t('Input')} ${$t('Assigned')}`" v-validate="'required'" /> -->
		<v-select
			:filter="fuseSearch"
			:clearable="false"
			class="border-none w-full"
			:placeholder="`${$t('Input')} ${$t('Assigned')}`"
			v-model="localValue"
			name="assigned"
			:options="$store.state.moduleUser.users"
			:reduce="
				assigned => {
					return { fullname: assigned.fullname, email: assigned.email };
				}
			"
			label="fullname"
			:data-vv-as="$t('Assigned')"
		>
			<template #no-options>
				Không có dữ liệu
			</template>
		</v-select>
		<span class="text-danger text-sm break-normal" v-show="errors.has('assigned')">{{ errors.first("assigned") }}</span>
	</div>
</template>

<script>
import vSelect from "vue-select";
import Helpers from '../../utils/helpers';

export default {
	name: "SelectAssigned",
	// inject: ["parentValidator"],
	components: { vSelect },
	props: {
		value: {
			required: true
		}
	},
	data() {
		return {
			assigned: null,
			localValue: null
		};
	},
	methods: {
		fuseSearch(options, search) {
			return options.filter(obj =>
				Helpers.removeVietnameseAccent(obj.fullname.toLowerCase()).includes(
					Helpers.removeVietnameseAccent(search.toLowerCase()),
				),
			);
		},
	},
	computed: {
		// localValue: {
		// 	get() {
		// 		return this.value;
		// 	},
		// 	set(val) {
		// 		// this.$emit("input", val);
		// 	}
		// }
	},
	watch: {
		// assigned() {
		// 	this.localValue = this.assigned;
		// },
		localValue() {
			this.$emit("input", this.localValue);
		}
	},
	created() {
		if (this.value) this.localValue = this.value;
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
		this.$store.dispatch("moduleUser/fetchUsers", {
			filters: {
				isTechnic: true
			},
			projection: {
				email: 1,
				fullname: 1,
				overview: 1
			},
			paging: {
				page: 1,
				limit: 400
			}
		});
	}
};
</script>

<style></style>
